/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Теперь наша команда Workplace Experience обработает запрос на подарок. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Похвала создана',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Не удалось создать похвалу или отправить подарок. Попробуйте создать отдельную заявку по ссылке <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Произошла ошибка',
  'team-central.give-kudos.button': 'Похвалить',
  'team-central.give-kudos.close-button.label': 'Закрыть панель',
  'team-central.give-kudos.confirm-close.title': 'Действительно закрыть?',
  'team-central.give-kudos.created.description.flag': 'Похвала отправлена. <a>Просмотреть похвалу</a>',
  'team-central.give-kudos.created.title.flag': 'Похвала создана',
  'team-central.give-kudos.creation.failed.description.flag': 'Не удалось создать похвалу.',
  'team-central.give-kudos.creation.failed.title.flag': 'Произошла ошибка',
  'team-central.give-kudos.error-icon.label': 'Ошибка',
  'team-central.give-kudos.success-icon.label': 'Готово',
  'team-central.give-kudos.unsaved.warning': 'Внесенные изменения не будут сохранены.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Отмена',
  'team-central.give-kudos.unsaved.warning.close': 'Закрыть'
};